import { Colors } from "@auteco/theme"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
    mainContainer: {
        padding: '20px'
    },
    filtersContainer: {
        padding: '4px 4px 20px',
        // background: 'white'
        background: Colors.GRAY_BACKGROUND
    },
    mainContainerBtns: {
        width: '600px',
        margin: '0 auto 12px',
        padding: '4px',
        background: Colors.GRAY_BACKGROUND,
        borderRadius: '4px'
    },
    containerBtns: {
        display: 'flex',
        borderRadius: '4px',
        overflow: 'hidden'
    },
    btn: {
        width: '200px',
        background: Colors.GRAY_BACKGROUND,
        borderRadius: '0',
        boxShadow: 'none'
    },
    selectedBtn: {
        width: '200px',
        borderRadius: '0',
        background: Colors.DARK_BLUE,
        color: 'white',
        '&:hover': {
            background: Colors.DARK_BLUE
        }
    },
}))

export default useStyles